import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import './smartTriggerCard.css'
import {useNavigate} from "react-router-dom";

export function AddNewSmartTriggerCard() {

    const navigate = useNavigate();

    return (
        <div className={"smart-trigger-card "}>
            <div className={"create-new-sm-button"}>
                <div>
                    <FontAwesomeIcon onClick={() => navigate("/smart/triggers/new")}
                                     className={"pointer smart-trigger-edit-button"} icon={faPlus}
                                     color={"rgb(173, 181, 189)"}
                                     size={"5x"}/>
                </div>
                <div>
                    <h2 className={"smart-trigger-card-name"}>Create New Smart Trigger</h2>
                </div>
            </div>

        </div>
    )
}
